export default "bd4f532f070b4eb5.svg"